<template>
  <div class="sb_button_container">
    <div
      v-if="hasDefaultSlot"
      class="sb_button_text"
    >
      <slot></slot>
    </div>
    <div
      v-if="icon"
      class="sb_button_icon"
    >
      <SvgIcon :icon-id="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonObject',
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    }
  }
};
</script>

<style lang="scss">
.sb_button {
  padding: .8rem 1rem;
  text-align: left;
  border-radius: .15rem;
  border: none;
  position: relative;
  transition: opacity .3s ease;
  font-size: 1.1rem;
  letter-spacing: .5px;
  background: none;
  color: $default-text-color;
  user-select: none;
  text-decoration: none;
  transition: color .3s ease, background-color .3s ease;
  margin: 0 .6rem .6rem 0;
  display: inline-flex;

  @include media(">=medium") {
    font-size: .95rem;
    padding: .6rem .8rem .7rem .6rem;
  }

  &_container {
      display: inline-flex;
      align-items: center;
  }

  &_text {
    line-height: 1;
  }

  &_icon {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      transform: scale(1.4);
  }


  &:focus, &:hover {
    color: currentColor;
    cursor: pointer;
    outline: none;
  }

  //
  // DISABLED
  //
  &:disabled {
    opacity: .4;
    pointer-events: none;
  }


  //
  // ICONS
  //
  &.v_has-icon-right {
    .sb_button_icon {
        margin-left: .6rem;
    }
  }
  &.v_has-icon-left {
    .sb_button_icon {
        margin-left: 0;
        margin-right: .6rem;
    }
    .sb_button_container {
      flex-direction: row-reverse !important;
    }
  }
  &.v_is-icon {
   padding: .6rem .7rem .7rem .7rem
  }
  &.v_icon-faded {
    .sb_button_icon {
      opacity: .5;
    }
  }

  // rotate icon
  .sb_icon {
      transition: transform .2s ease;
  }
  &.s_rotate-icon-180 {
    .sb_icon {
      transform: rotate(180deg);
    }
  }

  //
  // EXPAND
  //

  &.v_expanded {
    display: block;
    width: 100%;
    .sb_button_container {
      display: flex;
      justify-content: center;
    }
  }
  &.v_expand-on-small {
    @include media("<medium-portrait") {
      display: block;
      width: 100%;
      text-align: center;
      .sb_button_container {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
